module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.25401",
      "conversations-internal-schema": "static-1.12270",
      "head-dlb": "static-1.4465",
      "hs-test-utils": "static-1.7618",
      "hubspot-url-utils": "static-1.3818",
      "HubStyleTokens": "static-2.11064",
      "I18n": "static-7.1522",
      "jasmine-runner": "static-1.6087",
      "quartz": "static-1.6490",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.481",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.5774",
      "enviro": "static-4.345",
      "hs-promise-rejection-tracking": "static-1.4918",
      "PortalIdParser": "static-2.319",
      "raven": "static-3.5386",
      "raven-hubspot": "static-1.5693",
      "bend-plugin-trellis-migration": "static-1.3084",
      "moment": "static-3.26",
      "cv-backend-services": "static-1.1424",
      "hub-http": "static-1.5820",
      "immutable": "static-2.19",
      "immutable-less": "static-1.4281",
      "quartz-config": "static-1.268",
      "quartz-core": "static-1.5709",
      "transmute": "static-2.77",
      "HeadJS": "static-2.674",
      "react-dom": "static-7.85",
      "foundations-components": "static-1-ak-nestedtablestyle.42",
      "framer-motion": "static-1.61",
      "hs-test-utils-bend-plugin": "static-1.2729",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.144",
      "foundations-theming": "static-1.4038",
      "i18n-data": "static-1.214",
      "metrics-js": "static-1.9284",
      "moment-timezone": "static-5.76",
      "react-utils": "static-2.5025",
      "jasmine": "static-4.3964",
      "history": "static-4.47",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.57",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.8011",
      "visitor-ui-component-library-icons": "static-1.5585",
      "bender-build-tools": "static-1.2756",
      "bend-plugin-foundations-components": "static-1-ak-nestedtablestyle.42",
      "floating-ui": "static-1.49",
      "foundations-assets": "static-1.4462",
      "foundations-theming-specialty": "static-1.1754",
      "hs-story-utils": "static-1.9064",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.90",
      "tanstack-table": "static-1.23",
      "trellis-assets": "static-1.885",
      "ui-fonts": "static-1.337",
      "ui-images": "static-2.1036",
      "rpc-client-utils": "static-1.4251",
      "ts-schema": "static-1.3764",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.128",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.754",
      "hubspotter-http": "static-1.4325",
      "icons": "static-2.601",
      "mobile-manifest-mixins": "static-1.447",
      "quartz-auth": "static-1.165",
      "quartz-head": "static-1.155",
      "quartz-i18n": "static-1.165",
      "quartz-test": "static-1.165",
      "quick-fetch": "static-1.3587",
      "react-rhumb": "static-1.16270",
      "react-router-dom": "static-5.26",
      "bend-plugin-foundations-theming": "static-1.2521",
      "foundations-theming-base": "static-1.3023",
      "stylex": "static-1.25",
      "classnames": "static-2.10",
      "cssUtils": "static-1.678",
      "HubStyle": "static-2.11372",
      "react-input-autosize": "static-2.17",
      "sassPrefix": "static-1.148",
      "hub-http-shared-msw-handlers": "static-1.9080",
      "hubspotter-http-shared-msw-handlers": "static-1.9078"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.25401",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12270",
      "head-dlb": "/head-dlb/static-1.4465",
      "hs-test-utils": "/hs-test-utils/static-1.7618",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3818",
      "HubStyleTokens": "/HubStyleTokens/static-2.11064",
      "I18n": "/I18n/static-7.1522",
      "jasmine-runner": "/jasmine-runner/static-1.6087",
      "quartz": "/quartz/static-1.6490",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.481",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5774",
      "enviro": "/enviro/static-4.345",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
      "PortalIdParser": "/PortalIdParser/static-2.319",
      "raven": "/raven/static-3.5386",
      "raven-hubspot": "/raven-hubspot/static-1.5693",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3084",
      "moment": "/moment/static-3.26",
      "cv-backend-services": "/cv-backend-services/static-1.1424",
      "hub-http": "/hub-http/static-1.5820",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.4281",
      "quartz-config": "/quartz-config/static-1.268",
      "quartz-core": "/quartz-core/static-1.5709",
      "transmute": "/transmute/static-2.77",
      "HeadJS": "/HeadJS/static-2.674",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1-ak-nestedtablestyle.42",
      "framer-motion": "/framer-motion/static-1.61",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2729",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.144",
      "foundations-theming": "/foundations-theming/static-1.4038",
      "i18n-data": "/i18n-data/static-1.214",
      "metrics-js": "/metrics-js/static-1.9284",
      "moment-timezone": "/moment-timezone/static-5.76",
      "react-utils": "/react-utils/static-2.5025",
      "jasmine": "/jasmine/static-4.3964",
      "history": "/history/static-4.47",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.57",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.8011",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5585",
      "bender-build-tools": "/bender-build-tools/static-1.2756",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ak-nestedtablestyle.42",
      "floating-ui": "/floating-ui/static-1.49",
      "foundations-assets": "/foundations-assets/static-1.4462",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1754",
      "hs-story-utils": "/hs-story-utils/static-1.9064",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.90",
      "tanstack-table": "/tanstack-table/static-1.23",
      "trellis-assets": "/trellis-assets/static-1.885",
      "ui-fonts": "/ui-fonts/static-1.337",
      "ui-images": "/ui-images/static-2.1036",
      "rpc-client-utils": "/rpc-client-utils/static-1.4251",
      "ts-schema": "/ts-schema/static-1.3764",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.128",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.754",
      "hubspotter-http": "/hubspotter-http/static-1.4325",
      "icons": "/icons/static-2.601",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.447",
      "quartz-auth": "/quartz-auth/static-1.165",
      "quartz-head": "/quartz-head/static-1.155",
      "quartz-i18n": "/quartz-i18n/static-1.165",
      "quartz-test": "/quartz-test/static-1.165",
      "quick-fetch": "/quick-fetch/static-1.3587",
      "react-rhumb": "/react-rhumb/static-1.16270",
      "react-router-dom": "/react-router-dom/static-5.26",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2521",
      "foundations-theming-base": "/foundations-theming-base/static-1.3023",
      "stylex": "/stylex/static-1.25",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.678",
      "HubStyle": "/HubStyle/static-2.11372",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "sassPrefix": "/sassPrefix/static-1.148",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9080",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9078"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};